import React from 'react';
import Button from '../../Button';
import { LuCheck } from 'react-icons/lu';
import { SubscriptionTabStyle } from './SubscriptionTab.styles';

const SubscriptionTab = () => {
  return (
    <>
      <SubscriptionTabStyle>
        <div className="info-block">
          <div className="head">
            <strong className="title">Free</strong>
            <a href="/upgrade-plan">
              <Button width="100px" variant="secondary">
                Upgrade
              </Button>
            </a>
          </div>
          <div className="list-holder">
            <span className="subtitle">Your Free plan includes:</span>
            <ul className="list">
              <li>
                <LuCheck />
                Limited basic queries
              </li>
              <li>
                <LuCheck />
                Real-time answers powered by live web search
              </li>
            </ul>
          </div>
        </div>
      </SubscriptionTabStyle>
    </>
  );
};

export default SubscriptionTab;
